export const userIdentity = ({ user }) => {
  window.Appcues.page();
  window.Appcues.identify(user.id, {orgId: user.attributes.first_oid, ...user.attributes});
};
